import {
  FILTER_CUSTOM,
  FILTER_FOUR_WEEKS,
  FILTER_MONTH_TIL_TODAY,
  FILTER_ONE_WEEK,
  FILTER_ONE_YEAR,
  FILTER_QUARTER_TIL_TODAY,
  FILTER_YEAR_TIL_TODAY,
  SELECT_FILTER,
  SET_DATES,
  SET_DIRTY,
  RESET_DIRTY,
} from './constants';

export const initialState = {
  filters: [
    FILTER_ONE_WEEK,
    FILTER_FOUR_WEEKS,
    FILTER_ONE_YEAR,
    FILTER_MONTH_TIL_TODAY,
    FILTER_QUARTER_TIL_TODAY,
    FILTER_YEAR_TIL_TODAY,
  ],
  selectedFilter: FILTER_CUSTOM,
  dates: {
    first: {
      from: null,
      to: null,
    },
    second: {
      from: null,
      to: null,
    },
  },
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SELECT_FILTER:
      return {
        ...state,
        selectedFilter: payload,
      };

    case SET_DATES:
      return {
        ...state,
        dates: payload,
      };

    default:
      return state;
  }
};

const dirtyInitialState = { isDirty: false };
export const isDirtyReducer = (state = dirtyInitialState, { type }) => {
  switch (type) {
    case SET_DIRTY:
      return {
        ...state,
        isDirty: true,
      };

    case RESET_DIRTY:
      return {
        ...state,
        isDirty: false,
      };

    default:
      return state;
  }
};

export default reducer;
